module.exports = __webpack_public_path__ + "static/img/third3_1_2.d7010bdc.jpg";